import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isShopSubdomain } from '../utils/domainDetection';
import HomeLayout from '../components/shop/HomeLayout';
import ShopLayout from '../components/shop/ShopLayout';
import ProtectedRoute from '../components/ProtectedRoute';
import AdminGuard from '../components/AdminGuard';
import AuthRoutes from './AuthRoutes';
import {
  HomePage,
  Shop,
  ProductDetail,
  Checkout,
  OrderConfirmation,
  BrandPage,
  CustomerAuth,
  CustomerProfile,
  CustomerOrders,
  Terms,
  Privacy,
  ShopifyAppPrivacy,
  ReturnPolicy,
  Integrations,
  SellOnArkx,
  AccessRedeem,
  ArkxLogistics,
  Likes,
  OrderLookup,
  DriverDashboard,
} from './lazyPages';

export default function ShopRoutes({ isAuthenticated }: { isAuthenticated: boolean }) {
  const onShopSubdomain = isShopSubdomain();

  return (
    <Routes>
      {AuthRoutes({ isAuthenticated })}

      {onShopSubdomain ? (
        <>
          {/* Standalone pages (no layout wrapper) */}
          <Route path="/access/:token" element={<AccessRedeem />} />

          {/* shop.arkxla.com: product grid at root, no /shop prefix needed */}
          <Route path="/" element={<ShopLayout />}>
            <Route index element={<Shop />} />
            <Route path="stores" element={<Shop />} />
            <Route path="brand/:slug" element={<BrandPage />} />
            <Route path="product/:sku" element={<ProductDetail />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="order-confirmation/:orderNumber" element={<OrderConfirmation />} />
            <Route path="order/:orderNumber" element={<OrderConfirmation />} />
            <Route path="track/:orderNumber" element={<OrderConfirmation />} />
            <Route path="order-lookup" element={<OrderLookup />} />
            <Route path="account" element={<CustomerAuth />} />
            <Route path="profile" element={<CustomerProfile />} />
            <Route path="orders" element={<CustomerOrders />} />
            <Route path="likes" element={<Likes />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="privacy/shopify-app" element={<ShopifyAppPrivacy />} />
            <Route path="return-policy" element={<ReturnPolicy />} />
            {/* Redirect legacy /shop to root */}
            <Route path="shop" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </>
      ) : (
        <>
          {/* arkxla.com: landing page at root, shop pages under /shop */}
          <Route path="/" element={<HomeLayout />}>
            <Route index element={<HomePage />} />
            <Route path="terms" element={<Terms />} />
            <Route path="privacy" element={<Privacy />} />
            <Route path="privacy/shopify-app" element={<ShopifyAppPrivacy />} />
            <Route path="return-policy" element={<ReturnPolicy />} />
            <Route path="integrations" element={<Integrations />} />
            <Route path="integrations/shopify/privacy" element={<ShopifyAppPrivacy />} />
          </Route>

          {/* Standalone pages */}
          <Route path="/driver" element={<ProtectedRoute><AdminGuard><DriverDashboard /></AdminGuard></ProtectedRoute>} />
          <Route path="/sell" element={<SellOnArkx />} />
          <Route path="/logistics" element={<ArkxLogistics />} />
          <Route path="/access/:token" element={<AccessRedeem />} />

          {/* Shop routes */}
          <Route path="/*" element={<ShopLayout />}>
            <Route path="shop" element={<Shop />} />
            <Route path="stores" element={<Shop />} />
            <Route path="brand/:slug" element={<BrandPage />} />
            <Route path="product/:sku" element={<ProductDetail />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="order-confirmation/:orderNumber" element={<OrderConfirmation />} />
            <Route path="order/:orderNumber" element={<OrderConfirmation />} />
            <Route path="track/:orderNumber" element={<OrderConfirmation />} />
            <Route path="order-lookup" element={<OrderLookup />} />
            <Route path="account" element={<CustomerAuth />} />
            <Route path="profile" element={<CustomerProfile />} />
            <Route path="orders" element={<CustomerOrders />} />
            <Route path="likes" element={<Likes />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </>
      )}
    </Routes>
  );
}
